export var JustificationContext;
(function (JustificationContext) {
    JustificationContext[JustificationContext["None"] = 0] = "None";
    JustificationContext[JustificationContext["OverrideOneTimeException"] = 1] = "OverrideOneTimeException";
    JustificationContext[JustificationContext["OverrideNotSensitive"] = 2] = "OverrideNotSensitive";
    JustificationContext[JustificationContext["OverrideAuthorized"] = 3] = "OverrideAuthorized";
})(JustificationContext || (JustificationContext = {}));
export var SharePointItemType;
(function (SharePointItemType) {
    SharePointItemType[SharePointItemType["Invalid"] = 0] = "Invalid";
    SharePointItemType[SharePointItemType["File"] = 1] = "File";
    SharePointItemType[SharePointItemType["Folder"] = 5] = "Folder";
    SharePointItemType[SharePointItemType["Site"] = 6] = "Site";
    SharePointItemType[SharePointItemType["SiteCollection"] = 7] = "SiteCollection";
    SharePointItemType[SharePointItemType["Tenant"] = 8] = "Tenant";
    SharePointItemType[SharePointItemType["DocumentLibrary"] = 9] = "DocumentLibrary";
    SharePointItemType[SharePointItemType["Page"] = 11] = "Page";
})(SharePointItemType || (SharePointItemType = {}));
